import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';
import queryString from 'query-string';


Snappy.Component.EduFilters = class EduFilters extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-filters';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        if (this.$sortSelect.length) {
            this.initMobileSorting();
        }
        this.setChosenFiltersByQS();
    }

    setVars() {
        this.$document = $(document);
        this.$filters = this.$element.find('.js-filter');
        this.$sortInputs = this.$element.find('.js-filter-control[name=sortby]');
        this.$sortSelect = this.$element.find('.js-mobile-sort');
        this.$primaryFilters = this.$element.find('.js-filter-primary .js-filter');
        this.$openers = this.$element.find('.js-filter-opener');
        this.$overlayToggler = this.$element.find('.js-overlay-toggle');
        this.$dropdowns = this.$element.find('.js-filter-dropdown');
        this.$closeBtns = this.$element.find('.js-filter-close');
        this.$clearBtns = this.$element.find('.js-filter-clear');
        this.$clearAll = this.$element.find('.js-filter-clear-all');
        this.$mobileclearAll = this.$element.find('.js-mobile-clear-all');
        this.$applyAll = this.$element.find('.js-filters-apply-all');
        this.lastQS = '';
    }

    setEventListeners() {
        this.$window.on(
            'resize:finished',
            (this.bindedResize = this.onResize.bind(this))
        );


        this.$openers.on('click', this.toggleFilter.bind(this));
        this.$overlayToggler.on('click', this.toggleOverlay.bind(this));
        this.$closeBtns.on('click', this.closeHandler.bind(this));
        this.$clearBtns.on('click', this.clearBtnHandler.bind(this));
        this.$mobileclearAll.on('click', this.clearAllFilters.bind(this));
        this.$clearAll.on('click', this.clearAllFilters.bind(this));
        this.$filters.on('change', this.changeHandler.bind(this));
        this.$sortSelect.on('change', this.mobileSortHandler.bind(this));
        this.$applyAll.on('click', this.applyAllClickHandler.bind(this));

        this.setListenersByScreen();
    }

    setChosenFiltersByQS() {
        this.lastQS = window.location.search.slice(1);
        const qsParsed = queryString.parse(this.lastQS);
        const names = Object.keys(qsParsed);

        const inputsToCheck = [];
        const wrapper = this.$element[0];
        names.forEach((name) => {
            qsParsed[name] = window.decodeURIComponent(qsParsed[name]).split(',');
            qsParsed[name].forEach((val)=> {
                const input = wrapper.querySelector(`.js-filter-control[name='${name}'][value='${val}']`);
                if (input !== null) {
                    inputsToCheck.push(input);
                }

            });
        });

        for (let i = 0; i < inputsToCheck.length; i++) {
            inputsToCheck[i].checked = true;
        }

        this.updateAllFilters();
        if (this.lastQS) {
            this.$window.trigger('contentLoader:setQueryString', [this.lastQS]);
        }

    }

    initMobileSorting() {
        let optionsString = '';
        this.$sortInputs.each((i, item) => {
            optionsString += `<option value="${item.value}">${item.getAttribute('data-label')}</option>`;
        });

        this.$sortSelect[0].innerHTML = optionsString;
    }

    setListenersByScreen() {
        if (App.isDesktop) {
            this.$document.on('click', this.onDocumentClick.bind(this));
        }
    }

    closeHandler(e) {
        this.toggleFilter(e);
        this.applyFilters();
    }

    toggleFilter(e) {
        if (!App.isDesktop) {
            return;
        }

        this.$currentFilter = $(e.target).closest('.js-filter');
        this.$currentOpener = $(e.target).closest('.js-filter-opener');
        this[(this.$currentFilter.hasClass('is-opened')) ? 'close' : 'open']();
    }

    toggleOverlay() {
        this[(this.$element.hasClass('is-overlay-opened')) ? 'closeOverlay' : 'openOverlay']();
    }

    openOverlay() {
        this.$element.addClass('is-overlay-opened');
    }

    closeOverlay() {
        this.$element.removeClass('is-overlay-opened');
    }

    open() {
        this.closeAll();
        this.$currentFilter.addClass('is-opened');
        this.$currentOpener.attr('aria-expanded', 'true');
    }

    close() {
        this.$currentFilter.removeClass('is-opened');
        this.$currentOpener.attr('aria-expanded', 'false');
    }

    clearBtnHandler(e) {
        const $filter = $(e.target).closest('.js-filter');
        this.clearFilter($filter);
    }

    clearAllFilters() {
        this.$filters.each((i, el)=> {
            this.clearFilter($(el));
        });
        this.applyFilters();
    }

    clearFilter($filter) {
        const $inputs = $filter.find('.js-filter-control');
        $inputs.prop('checked', false);
        EduFilters.updateFilter($filter);
    }

    closeAll() {
        this.$filters.removeClass('is-opened');
        this.$openers.attr('aria-expanded', 'false');
    }

    closeFilter($filter) {
        $filter.removeClass('is-opened');
        const $opener = $filter.find('.js-filter-opener');
        $opener.attr('aria-expanded', 'false');
    }

    applyFilters() {
        const qs = this.getQueryString();
        if (this.lastQS !== qs) {

            this.$window.trigger('contentLoader:loadByQueryString', [qs]);
            this.lastQS = qs;
            this.trackFilter();
        }
    }

    applyAllClickHandler() {
        this.applyFilters();
        this.closeOverlay();
    }

    changeHandler(e) {
        const $filter = $(e.delegateTarget);
        EduFilters.updateFilter($filter);
        this.updateClearAllbtn();
        if ($filter[0].hasAttribute('data-filter-auto-apply')) {
            this.applyFilters();
            this.closeFilter($filter);
        }

    }

    mobileSortHandler() {
        const sortVal = this.$sortSelect.val();
        this.$sortInputs.each((i, item) => {
            item.checked = (item.value === sortVal);
        });
        this.applyFilters();
    }

    onDocumentClick(e) {
        if (!$(e.target).closest('.js-filter, .js-filter-clear-all').length) {
            if (this.$filters.filter('.is-opened').length) {
                this.closeAll();
                this.applyFilters();
            }

        }
    }


    getQueryString() {
        const qsByName = {};
        const $checkedControls = this.$element.find('.js-filter-control:checked');
        $checkedControls.each((i, el) => {
            if (!qsByName[el.name]) {
                qsByName[el.name] = [];
            }
            qsByName[el.name].push(el.value);
        });

        const names = Object.keys(qsByName);
        names.forEach((name)=> {
            qsByName[name] = qsByName[name].join(',');
        });

        return queryString.stringify(qsByName);

    }

    getTrackingFilterString() {
        const arr = [];
        const $checkedControls = this.$element.find('.js-filter-control:checked');
        $checkedControls.each((i, el) => {
            arr.push(`${el.name}: ${el.getAttribute('data-label')}`);
        });

        return arr.join(' > ');
    }

    trackFilter() {
        const trackingData = this.getTrackingFilterString();
        if (trackingData) {
            $(window).trigger('gtm:send', [ 'Filter', trackingData, document.title]);
        }

    }

    updateClearAllbtn() {

    }

    onResize() {

    }

    updateAllFilters() {
        this.$filters.each((i, filter) => {
            EduFilters.updateFilter($(filter));
        });
    }

    static getCheckedCount($filter) {
        const $checkedControls = $filter.find('.js-filter-control:checked');
        return $checkedControls.length;
    }

    static updateFilter($filter) {
        const checkedCount = EduFilters.getCheckedCount($filter);
        if (checkedCount > 0) {
            if ($filter.closest('.js-filter-primary').length) {
                $filter.addClass('is-dirty');
            }

            const $count = $filter.find('.js-filter-checked-count');
            if ($count.length) {
                $count.html(checkedCount);
            }

        }
        else {
            $filter.removeClass('is-dirty');
        }

        const $chosenLabel = $filter.find('.js-filter-chosen');
        if ($chosenLabel.length) {
            if (checkedCount > 0) {
                const $checkedControl = $filter.find('.js-filter-control:checked');
                const checkedLabel = $checkedControl.data('label');
                $chosenLabel.text(`: ${checkedLabel}`);
            }
            else {
                $chosenLabel.empty();
            }
        }
    }
};



// WEBPACK FOOTER //
// ./components/edu-filters/scripts/edu-filters.js